import * as React from 'react';
import { SVGProps } from 'react';

export const SvgDocumentDefault = (props: SVGProps<SVGSVGElement>) => (
    <svg width={14} height={18} viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M8.89.25H1.988C1.04.25.272 1.038.272 2L.264 16c0 .962.767 1.75 1.716 1.75h10.36c.949 0 1.725-.788 1.725-1.75V5.5L8.889.25Zm1.725 14H3.714V12.5h6.9v1.75Zm0-3.5H3.714V9h6.9v1.75ZM8.027 6.375V1.562l4.744 4.813H8.027Z"
            fill="#007AFF"
        />
    </svg>
);
